import React from "react";
import { Link } from "react-router-dom";

const FilterHeader = () => {
  return (
    <div>
      {" "}
      <div className="flex  space-x-4r mt-8 ml-4 ">
        <div className="relative h-auto w-48 left-1 mt-4 mb-4 hidden sm:block">
          <label htmlFor="Search" className="sr-only">
            {" "}
            Search{" "}
          </label>

          <input
            type="text"
            id="Search"
            placeholder="  Search for..."
            className="w-full rounded-md border-gray-200 py-2.5 pe-10 shadow-sm sm:text-sm"
          />

          <span className="absolute inset-y-0 end-0 grid w-10 place-content-center bg-gray-200">
            <button type="button" className="text-gray-600 hover:text-gray-700">
              <span className="sr-only">Search</span>

              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="h-4 w-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
                />
              </svg>
            </button>
          </span>
        </div>

        <div className="w-1/5 mr-6 mb-4 ml-3">
          <label
            htmlFor="HeadlineAct"
            className="block text-sm font-medium text-gray-500 w-24"
          >
            Practice Status
          </label>

          <select
            name="HeadlineAct"
            id="HeadlineAct"
            className="mt-1.5 h-9 p-2 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm"
          >
            <option value="">Please select</option>
            <option value="JM">John Mayer</option>
          </select>
        </div>

        <div className="w-1/5 mr-6">
          <label
            htmlFor="HeadlineAct"
            className="block text-sm font-medium  text-gray-500 w-16"
          >
            Order By
          </label>

          <select
            name="HeadlineAct"
            id="HeadlineAct"
            className="mt-1.5 h-9 p-2 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm"
          >
            <option value="">Please select</option>
            <option value="JM">John Mayer</option>
          </select>
        </div>

        <div className="w-24 mr-6">
          <label
            htmlFor="HeadlineAct"
            className="block text-sm font-medium text-gray-500"
          >
            Badge
          </label>

          <select
            name="HeadlineAct"
            id="HeadlineAct"
            className="mt-1.5 h-9 p-2 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm"
          >
            <option value="">Please select</option>
            <option value="JM">John Mayer</option>
          </select>
        </div>

        <div className="w-24 mr-6">
          <label
            htmlFor="HeadlineAct"
            className="block text-sm font-medium text-gray-500"
          >
            Complexity
          </label>

          <select
            name="HeadlineAct"
            id="HeadlineAct"
            className="mt-1.5 h-9 p-2 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm"
          >
            <option value="">Please select</option>
            <option value="JM">John Mayer</option>
          </select>
        </div>

        <div className="w-24 mr-6 hidden sm:block">
          <label
            htmlFor="HeadlineAct"
            className="block text-sm font-medium text-gray-500"
          >
            Pagination
          </label>

          <select
            name="HeadlineAct"
            id="HeadlineAct"
            className="mt-1.5 h-9 p-2 w-full rounded-sm border-gray-300 text-gray-700 sm:text-sm"
          >
            <option value="">Please select</option>
            <option value="JM">John Mayer</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterHeader;
